






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Copyable extends Vue {
  @Prop({ required: true })
  private readonly link!: string;

  copy () {
    let success = false

    if (!navigator.clipboard) {
      const elem = this.$refs.input as HTMLInputElement

      elem.focus()
      elem.select()

      try {
        success = document.execCommand('copy')
      } catch (ex) {
        console.log(ex)
      }

      if (!success) prompt('Copy the text below:', this.link)
    } else {
      navigator.clipboard.writeText(this.link).then(() => {
        success = true
      }).catch((err) => {
        console.log(err)

        prompt('Copy the text below:', this.link)
      })
    }
  }
}
